export const MISC_PATH = {
  MANAGE_USER: '/misc/manageUser',
  DELIVERY_MESSAGE: '/misc/deliveryMessage',
};
